import React from 'react';

const Hero = ({ language }) => {
  const texts = {
    lt: {
      eyebrow: 'Filmų peržiūros gidas',
      title: 'Vakaras prasideda nuo aiškaus pasirinkimo',
      subtitle: 'Filmviewing sudėlioja filmus į nuotaikos takelius ir trumpas peržiūros pastabas. Pirmiausia kontekstas, tada seansas.',
      cta: 'Tęsti į paslaugą',
      frame: '01 / Salė prieš seansą',
      alt: 'Tuščia kino salė su raudonomis kėdėmis',
    },
    en: {
      eyebrow: 'A film viewing guide',
      title: 'The evening starts with a clear choice',
      subtitle: 'Filmviewing arranges films into mood lanes and short viewing notes. Context first, then the screening.',
      cta: 'Continue to the service',
      frame: '01 / The room before the film',
      alt: 'An empty cinema with red seats',
    },
  };

  const t = texts[language];

  return (
    <section id="section-1" className="border-b border-white/10">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 py-16 lg:grid-cols-12 lg:py-24">
        <div className="lg:col-span-6">
          <p className="text-xs uppercase tracking-[0.28em] text-amber">{t.eyebrow}</p>
          <h1 className="mt-5 font-heading text-5xl leading-[1.05] text-paper sm:text-6xl">
            {t.title}
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-sand">{t.subtitle}</p>
          <a href="/s" className="mt-8 inline-flex bg-amber px-6 py-3 font-medium text-ink">
            {t.cta}
          </a>
        </div>
        <div className="lg:col-span-6">
          <figure className="border border-white/15 bg-black p-3">
            <img
              src="https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?auto=format&fit=crop&w=1600&q=80"
              alt={t.alt}
              className="h-[420px] w-full object-cover sm:h-[520px]"
            />
            <figcaption className="flex items-center justify-between px-1 pt-3 text-xs uppercase tracking-[0.22em] text-sand">
              <span>{t.frame}</span>
              <span>Filmviewing</span>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Hero;
